<template>
    <div class="ccpay-Receivables">
    
    <div class="ccpay-Receivables-header">
       
        <span>收款帳戶資訊</span>
        <span @click="Add()" style="color: #26a2ff;">增加帳戶</span>
    </div>
     <!-- <article class="nav-title">
      <mt-header title="收款帳戶" fixed style="padding:1rem 1rem">
        <span slot="right">增加帳戶</span>
      </mt-header>
    </article> -->
    <div> 
    <div class="ccpay-Receivables-content card-css" style="margin-bottom:0">
        <p style="margin-bottom:1rem"><span style="color: #18D5AB;" @click="onTotalflag"> {{Totalflag?'切换今日':'切换本月'}}</span></p>
        <div class="ccpay-Receivables-card" v-show="Totallist">
            <div class="ccpay-Receivables-cardbox card-css">
                <p>{{Totalflag?'总额收款（USDT）':'今日收款（USDT）'}}</p>
                <p>{{toFixed(Totallist[0].order_amount,2)}}</p>
                <p>訂單数：{{Totallist[0].order_count}}</p>
            </div>
            <div class="ccpay-Receivables-cardbox card-css">
                <p>{{Totalflag?'总额付款（USDT）':'今日付款（USDT）'}}</p>
                <p>{{toFixed(Totallist[1].order_amount,2)}}</p>
                <p>訂單数：{{Totallist[1].order_count}}</p>
            </div>
        </div>
        <div class="ccpay-Receivables-tab">
            <div :class="!isTabPay?'class-tab':''" @click="tabclick(false)">銀行卡<span ></span></div>
            <div  :class="isTabPay?'class-tab':''" @click="tabclick(true)">支付寶<span ></span></div>
        </div>
     
    
 </div>
       <div class="ccpay-Receivables-list">
            <ul>
                <li class="card-css" v-for="(item,index) in data" :key="index" v-show="isTabPay&&item.account_type=='ALIPAY'">
                   <!-- <div class="ccpay-Receivables-list-li-left">
                         <img src="../../../static/img/emoji.png"/>
                    </div>-->
                    <div class="ccpay-Receivables-list-li-right">
                        <p class="ccpay-r-l-l-r-b ccpay-Receipt-t-switch">
                            <span>姓名：{{item.account_name}}</span>
                             
                            <mt-switch :value.sync="item.is_orders" @change="buyflag(index,item.is_orders,item.id)" ></mt-switch>
                        </p>
                        <p class="">帳號：{{item.user_id}} 
                        </p> 
                        <p class="ccpay-r-l-l-r-p"><span>收款限額（CNY）</span>
                         <span style="float:right;color: #E8D1B1;">{{item.collection_line}}</span></p>
                         <p><span style="float:right;color: #BABAC4;" @click="editpay(item)">编辑</span></p>
                    </div>
                </li>
                <li class="card-css" v-for="(item,index) in data" :key="index" v-show="!isTabPay&&item.account_type=='BANKPAY'">
                   <!--  <div class="ccpay-Receivables-list-li-left">
                         <img src="../../../static/img/emoji.png"/>
                    </div> -->
                    <div class="ccpay-Receivables-list-li-right">
                        <p class="ccpay-r-l-l-r-b ccpay-Receipt-t-switch" >
                            <span>姓名：{{item.account_name}}</span> 
                            <mt-switch :value.sync="item.is_orders" @change="buyflag(index,item.is_orders,item.id)" ></mt-switch>
                        </p>
                         <p class="">帳號：{{item.platform_account_no}}</p>
                        <p>銀行名稱：{{item.bank_name}} {{item.bank_branch_name}}</p>
                        <p>當日交易：{{item.today_count || 0}}笔 / {{item.today_legal_amount || 0}}</p>
                        <p class="ccpay-r-l-l-r-p"><span>收款限額（CNY）</span>
                         <span style="float:right;color: #E8D1B1;">{{item.collection_line}}</span></p>
                         <p> <span style="float:right;color: #BABAC4;" @click="editMerchant(item)">编辑</span></p>
                    </div>
                </li>
                <!-- <li>
                    <div class="ccpay-Receivables-list-li-left">
                        <img src="../../../static/img/Health.png"/>
                    </div>
                    <div class="ccpay-Receivables-list-li-right">
                        <p class="ccpay-r-l-l-r-b">
                            <span>村花</span> <span style="float:right;color: #BABAC4;">编辑</span></p>
                        <p>15011300176@163.com</p>
                        <p class="ccpay-r-l-l-r-p"><span>今日收款（CNY）</span> <span style="float:right;color: #E8D1B1;">9999.00</span></p>
                    </div>
                </li> -->
            </ul>
        </div>
        </div>
    </div>
    
</template>

<script> 
import {toFixed} from '../../public/index.js'
import { Indicator } from 'mint-ui';
export default {
    data(){
        return{
            isTabPay:false,//切换
            data:[],
            radvalue:false,
            open_buy:false,
            Totalflag:false,
            Totallist:null
        }
    },
    mounted(){
        this.numbercount()
        Indicator.open();
        this.$axios.get('/v1/account/amount/history?page=1&per_page=10&sortby=id&order=0&type=-1&symbol=USDT&start=2019-06-07&end=2019-08-07&source=BUY')
        .then(res=>{
             if(res.code==0){
                 this.getdatalist()
             }
             
        })
        // this.$ModelToast(true)
          
    },
    methods: {
        getdatalist(){
            this.$axios.get('/v1/traders/payaccount/list').then(res=>{
            Indicator.close();
                if(res.code==0){
                    this.data = res.data
                    this.data.forEach((item,index)=>{
                        item.is_orders = Boolean(item.is_orders)
                        // item.is_buy  =false
                    })
                }
            })
        },
        toFixed,
        onTotalflag(){
            this.Totalflag = !this.Totalflag
            Indicator.open();
            if(this.Totalflag){
                  this.$axios.get('/v1/traders/order/statistics/cur_month').then(res=>{
                       Indicator.close();
                      if(res.code==0){
                        this.Totallist = res.data
                        // console.log(this.Totallist,'zong')
                      }
                  })
            }else{
                this.$axios.get('/v1/traders/order/statistics/today').then(res=>{
                     Indicator.close();
                      if(res.code==0){
                        this.Totallist = res.data
                        // console.log(this.Totallist,'jin')
                      }
                  })
            }
        },
        numbercount(){
             this.$axios.get('/v1/traders/order/statistics/today').then(res=>{
                      if(res.code==0){
                        this.Totallist = res.data
                      }
             })
        },
        //tab切换
        tabclick(type){
            this.isTabPay = type
        },
        //增加
        Add(){

            // this.$MessageBox.alert('使用支付寶收款')
            // return
          this.$MessageBox.confirm('',{
                title:'增加帳戶',
                message:`请选择您要增加的类型 `,
                confirmButtonText:'銀行卡',
                cancelButtonText:'二维码'
            }).then(action => {
               
                if (action == 'confirm') {
                    this.$router.push({
                        path:'/addMerchant',
                        query:{type:2}
                    })
                    // console.log('銀行卡'); 
                }
            }).catch(error =>{

                if(error == 'cancel'){
                    this.$router.push({
                        path:'/addMerchant',
                        query:{type:1}
                    })
                    // console.log('支付寶');
                }
            })
        },
        editMerchant(item){
             this.$router.push({
                        name:'addMerchant',
                        query:{
                            type:4,
                            item: JSON.stringify(item)
                        }
                    })
        },
        //编辑
        editpay(item){
             this.$router.push({
                        name:'addMerchant',
                        query:{
                            type:3,
                            item:JSON.stringify(item)
                        }
                    })

            
        },
        buyflag(idx,state,id){
            let enable;
            if(state==0){
                this.data[idx].is_orders = true
                enable = true
            }else{
                 this.data[idx].is_orders = false
                 enable = false
            }
             Indicator.open();
            this.$axios.post('/v1/traders/payaccount/paystatus/set',{
                "enable": enable,
                 "id": id
            }).then(res=>{
                Indicator.close();
                if(res.code==0){
                        if(enable){
                             this.$Toast('该收款帳戶已启动')
                        }else{
                            this.$Toast('该收款帳戶已关闭')
                        }
                       
                    }else{
                        this.$Toast(res.msg)
                    }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.card-css{
        color: #666666;
            margin-top: 24px;
            margin-bottom: 2rem;
            -webkit-transform: translateZ(0px);
            transform: translateZ(0px);
            font-size: 14px;
            -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            border-radius: 8px;
            transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;
    }
    .ccpay-Receipt-t-switch{
        display: flex;
        align-items: center;
        justify-content: space-between;
             
    }
    .ccpay-Receivables{
        // height: 100%;
        // background: #F8F8F8;
        padding-bottom:4rem;
        .ccpay-Receivables-header{
            font-weight: 500;
             border-bottom: 1px solid #ccc;
            padding-bottom: 0.2rem;
            position: fixed;
            top: 0;
            z-index: 999;
            height: 3rem;
            line-height: 3rem;
            width: 100%;
            background: white;
            display: flex;
            justify-content: space-around;
            // background: white;
            // display: flex;
            // justify-content: space-between;
            // padding: 1rem;
        }
        .ccpay-Receivables-content{
            margin-top: 3rem;
             background: white;
            padding: 1rem;
             padding-right: 0;
        }
        .ccpay-Receivables-card{
             background: white;
            display: flex;
            .ccpay-Receivables-cardbox:nth-of-type(1){
                background: #18D5AB;
            }
            .ccpay-Receivables-cardbox:nth-of-type(2){
                background: #6683FB;
            }
            .ccpay-Receivables-cardbox{
                background: red;
                margin-right: 1rem;
                flex: 1;
                padding-left:1rem;
                padding-right: 1rem;
                border-radius: 10px;
                padding-bottom: 0.5rem;
                p{
                    position: relative;
                    padding: 0.8rem 0rem;
                    color: white;
                    font-size: 0.93rem;
                }
            }
        }
        .ccpay-Receivables-tab{
             background: white;
            // margin-top: 2.5rem;
            margin-bottom: 1rem;
            // margin-bottom: 2rem;
            div{
                display: inline-block;
                margin-right: 2rem;
            }
            .class-tab{
                font-size: 1.5rem;
                position: relative;
                color: rgb(38, 162, 255);
                span{
                     position: absolute;
                    font-size: 1.5rem;
                    left: 50%;
                    width: 1.875rem;
                    height: 2px;
                    background:  rgb(38, 162, 255);
                 
                    bottom: -0.625rem;
                    margin-left: -0.9375rem;
                }
            }
        }
        .ccpay-Receivables-list{
            padding: 1rem;
            li{
                margin-bottom: 1rem;
                padding: 1rem;
                // padding-bottom:1.5rem;
                background: white;
                // height:4rem;
                display: flex;
                
                .ccpay-Receivables-list-li-left{
                    width: 2rem;
                    float: left;
                    margin-right: 1rem;
                    //  height: 4rem;
                    img{
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        object-fit: cover;
                    }
                }
                .ccpay-Receivables-list-li-right{
                   
                   
                    flex:1;
                    p{
                        line-height: 2.5rem;
                        margin-bottom: 0.2rem;
                        border-bottom:1px solid #eee;
                        padding-bottom:5px;
                        
                    }
                    p:nth-child(even){
                        // background: #eee;
                    } 
                    p:last-child{
                        
                        border-bottom:none;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/index/Receivables.vue